<template>
  <div>
    <div class="box-title">
      <div class="box-title-text">用戶詳情</div>
      <el-button type="info"  v-if="userInfoRoleRoleId != teacherRoleId" @click="onEdit">編輯</el-button>
    </div>
    <div class="box">
      <vue-dividing-line title="家長帳號信息"></vue-dividing-line>
      <el-row :gutter="20" type="flex">
        <el-col class="el-col-text" :span="12">
          電郵地址：{{ from.email }}
        </el-col>
        <el-col class="el-col-text" :span="12">
          用戶姓名：{{ from.name }}
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex">
        <el-col class="el-col-text" :span="12">
          電話：+{{ from.areaCode }}&nbsp;{{ from.phone }}
        </el-col>
        <el-col class="el-col-text" :span="12">
          地址：{{from.country}} {{from.area}} {{from.district}} {{ from.address }}
        </el-col>
      </el-row>
      <vue-dividing-line title="學生帳號信息"></vue-dividing-line>
      <div
        class="student-account-information-row"
        v-for="(item, index) in from.students"
        :key="index"
      >
        <el-row :gutter="20" type="flex">
          <el-col class="el-col-text" :span="12">
            <el-row type="flex" align="middle">
              <el-col :span="3">
                <el-avatar
                  size="large"
                  :src="
                    item.avatar
                      ? item.avatar
                      : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                  "
                ></el-avatar>
              </el-col>
              <el-col :span="20">
                <div class="subscribe-title">學生{{ index |  studentIndex}}</div>
                <div>
                  學生帳號：{{ item.userNo }}
                  <span v-if="item.studentCode"
                    >(分校學生編號：{{ item.studentCode }})</span
                  >
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex">
          <el-col class="el-col-text" :span="12">
            學生名稱：{{ item.name }}
          </el-col>
          <el-col class="el-col-text" :span="12">
            性別：{{ item.gender | gender }}
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex">
          <el-col class="el-col-text" :span="12">
            分校：<span v-if="item.branchSchool">{{
              item.branchSchool.abbreviation
            }}</span>
          </el-col>
          <el-col class="el-col-text" :span="12">
            年級：<span v-if="item.grade">{{ item.grade.name }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex">
          <el-col class="el-col-text" :span="12">
            生日日期：{{ item.birthday | formatDate }}
          </el-col>
          <el-col class="el-col-text" :span="12">
            訂閱狀態:
            <span v-if="item.subscriptions.length">
              <subscriptionStatus :subscriptionItem="item.subscriptions[0]"></subscriptionStatus>
             
            </span>
          </el-col>
        </el-row>
        <el-row  type="flex" v-if="userInfoRoleRoleId != teacherRoleId">
          <el-col>
            <span
              class="text-line-button cursor-pointer"
              @click="onAddSubscribe(item)"
            >
              <i class="el-icon-circle-plus-outline"></i>新增訂閱
            </span>
          </el-col>
        </el-row>
       
        <div class="subscribe-box" v-if="item.subscriptions.length">
          <div class="subscribe-title">訂閱進度</div>
          <el-table :data="item.subscriptions">
            <el-table-column prop="gradeName" label="年級"> </el-table-column>
            <el-table-column label="訂閱狀態">
              <template slot-scope="{ row }">
                <subscriptionStatus :subscriptionItem="row"></subscriptionStatus>
              </template>
            </el-table-column>
            <el-table-column label="訂閱時段">
              <template slot-scope="{ row }">
                <span>{{ row.startDate | formatDate }}</span>--<span>{{ row.endDate | formatDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="付款類型">
              <template slot-scope="{ row }">
                <span>{{ row.type | paymentType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="upgradedType" label="升級狀態">
              <template slot-scope="{ row }">
                 <div v-if="!row.upgradedAt && row.gradeName == '小六'">--</div>
                <div v-else>
                  <span>{{ row.upgradedAt | formatDate }}</span
                  > <span>{{setUpgradedTypeLabel(row.upgradedType)}}</span> <span>{{ row.upgradedType | upgradedType }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="userInfoRoleRoleId != teacherRoleId">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="
                    (dateJudge(scope.row.startDate, scope.row.endDate) == 2 ||
                      dateJudge(scope.row.startDate, scope.row.endDate) == 3) &&
                    scope.$index == 0 && scope.row.type !== 0 && scope.row.type !== 3
                  "
                  size="medium"
                  @click="onEditorButton(scope.row)"
                  >編輯</el-button
                >
                <el-button
                  type="text"
                  v-if="
                    ((dateJudge(scope.row.startDate, scope.row.endDate) == 2 ||
                      dateJudge(scope.row.startDate, scope.row.endDate) == 3) &&
                    scope.$index == 0) && scope.row.gradeName !== '小六'
                  "
                  size="medium"
                  @click="onUpgradesButton(scope.row.id)"
                  >升級</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
      <account-information-dialog :dialogTitle="dialogTitle" ref="formLabelAlignRef" :grades="grades" :formLabelAlign="formLabelAlign"></account-information-dialog>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </dialogSlotVisible>
  </div>
</template>

<script>
import accountInformationDialog from './components/accountInformationDialog.vue';
import {getGrades} from '@/api/grade'
import moment from "moment";
import {
  putSubscription,
  addSubscription,
  subscriptionUpgradeRequest,
} from "@/api/subscription";
import { getUserDetail } from "@/api/users";
import dialogSlotVisible from "@/components/dialogSlotVisible";
import subscriptionStatus from './components/subscriptionStatus'
export default {
  components: { dialogSlotVisible,subscriptionStatus,accountInformationDialog },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEditSubscribe: false,
      dialogTitle: "新增訂閱",
      studentId: 0,
      formLabelAlign: {
        id: null,
        studentId: null,
        gradeId: null,
        type: null,
        startDate: null,
        endDate: null,
        date: "",
        upgradeWill: null,
        subscribeStatus: null,
        upgradedAt: null,
        upgradedType: null,
      },
      tableData: [],
      grades: [],
      centerDialogVisible: false,
      from: {},
    };
  },
  created() {
    this.getUserDetail();
    this.getGrades()
  },
  methods: {
    getGrades(){
      getGrades().then((res)=>{
         this.grades = res.data
      })
    },
    setUpgradedTypeLabel(type){
         switch (type) {
          case 1:
            return "學生滿星";
          case 2:
            return "在後台";
         }
    },
    getThreeMonthAgo(endDate) {
      var a = moment();
      var b = moment(endDate);
      return b.diff(a, "months");
    },
    dateJudge(startDate, endDate) {
      let status = 0;
      let startDates=moment(startDate).format('YYYY-MM-DD')
      let endDates=moment(endDate).format('YYYY-MM-DD')
      let nowDate=moment().format('YYYY-MM-DD')
      if (nowDate <startDates) {
        // status = 1;
        return  status = 1
      }else if (nowDate == endDates) {
        // status = 4;
        return status = 4;
      } else  if (nowDate > endDates) {
        // status = 5;
        return status = 5;
      } else  if (this.getThreeMonthAgo(endDate) <= 3 && nowDate >= startDates) {
        // status = 3;
        return status = 3;
      }  else   if (nowDate >= startDates && nowDate < endDates) {
        // status = 2;
        return status = 2;
      }
      return status;
    },
    onSubmit() {
      this.$refs.formLabelAlignRef.$refs.formLabelAlignRef.validate((valid) => {
        if (valid) {
          if (this.isEditSubscribe) {
            this.putSubscription();
          } else {
            this.addSubscription();
          }
        }
      })
    },
    onBack() {
      this.centerDialogVisible = false;
    },
    onAddSubscribe(item) {
       Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
      })
      this.isEditSubscribe = false;
      this.studentId = item.id;
      this.centerDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.formLabelAlignRef.$refs.formLabelAlignRef.clearValidate();
      })
    },
    onEditorButton(row) {
      this.isEditSubscribe = true;
      this.formLabelAlign = Object.assign({},row);
      this.dialogTitle = "編輯訂閱";
      this.centerDialogVisible = true;
    },
    onUpgradesButton(id) {
      this.subscriptionUpgradeRequest(id);
    },
    addSubscription() {
      this.formLabelAlign.id = this.id;
      this.formLabelAlign.studentId = this.studentId;
      addSubscription(this.formLabelAlign)
        .then(() => {
          this.getUserDetail()
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    putSubscription() {
      putSubscription(this.formLabelAlign.id,this.formLabelAlign).then(() => {
        //弹出消息
        this.$message({
          message: "修改成功",
          type: "success",
        });
         this.getUserDetail()
      }).finally(()=>{
        this.centerDialogVisible = false;
        this.getUserDetail()
      });
    },
    subscriptionUpgradeRequest(id) {
      subscriptionUpgradeRequest(id).then(() => {
        //弹出消息
        this.$message({
          message: "訂閱升級成功",
          type: "success",
        });
      }).finally(()=>{
        this.getUserDetail()
      });
    },
    getUserDetail() {
      getUserDetail(this.id).then((v) => {
        this.from = v.data;
      });
    },
    onEdit() {
      let path = `/user/${this.id}/edit`
      if(this.$route.meta.name === '/student'){
        path = `/student/${this.id}/edit`
      }else{
        path = `/user/${this.id}/edit`
      }
      this.resolveRouter(path)
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #fff;
  padding: 20px;
  min-height: 100vh;
}
.box-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.box-title-text {
  font-size: 22px;
  color: #ea4c4e;
}
.el-col-text {
  margin-bottom: 20px;
}
.student-account-information-row {
  border-bottom: 1px solid;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.subscribe-title {
  margin-bottom: 20px;
  color: #b62d2e;
  font-size: 20px;
}
.rowStatus-text-subscribing{
  color: #399500;
}
.rowStatus-text-status{
  color: #FF0000;
}
</style>